import { ErrorPageComponent } from './themes/content/error-page/error-page.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThemeBaseComponent } from './themes/base/theme-base.component';
import { LandingPageComponent } from './modules/sidebar-views/pages/landing-page/landing-page.component';
import { PermissionGuard } from './core/guard/permission.guard';
import { ApplicationPermissions } from './core/application-permission';
import { UWAdminGuard } from './core/guard/uw-admin.guard';
import { ChangePasswordComponent } from './modules/auth/pages/change-password/change-password.component';
import { HelpDeskComponent } from './help-desk/help-desk.component';
import { FaqsComponent } from './faqs/faqs.component';
import { AuthGuard } from './core/guard/auth.guard';

const routes: Routes = [
  // login, forgot password and reset-password routes are not supported in Admin app anymore. 
  // Refer to AuthGuard which navigates the user to donor login/registration page.
  // {
  //   path: 'login',
  //   component: LoginPageComponent,
  //   resolve: {
  //     auth: AuthPagesResolver
  //   },
  // },
  // {
  //   path: 'forgot-password',
  //   component: ForgotPasswordComponent,
  //   resolve: {
  //     auth: AuthPagesResolver
  //   },
  // },
  {
    path: 'private',
    component: ThemeBaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'help-desk',
        component: HelpDeskComponent,

      },
      {
        path: 'faqs',
        component: FaqsComponent,
      },
      {
        path: 'landing',
        component: LandingPageComponent,
        outlet: 'sidebar',
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        outlet: 'sidebar',
      },
      {
        path: 'canvasser',
        loadChildren: () =>
          import('@uw/modules/canvasser/canvasser.module').then(
            (m) => m.CanvasserModule
          )

      },
      {
        path: 'uwsetup',
        canActivate: [UWAdminGuard],
        loadChildren: () =>
          import('@uw/modules/uwsetup/uwsetup.module').then(
            (m) => m.UwsetupModule
          ),
        data: { permission: [ApplicationPermissions.uwUserSetup] }
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('@uw/modules/admin-setup/admin-setup.module').then(
            (m) => m.AdminSetupModule
          ),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('@uw/modules/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
        data: { permission: [ApplicationPermissions.uwCampaignProfile] }
      },
      {
        path: 'company',
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('@uw/modules/company/company.module').then(
            (m) => m.CompanyModule
          ),
        data: { permission: [ApplicationPermissions.wrkPlCompanyLevel, ApplicationPermissions.unitedWayAdmin] }
      },
      {
        path: 'campaign',
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('@uw/modules/campaign/campaign.module').then(
            (m) => m.CampaignModule
          ),
        data: {
          permission: [ApplicationPermissions.wrkPlCampaignSetup,
          ApplicationPermissions.wrkPlCompanyLevel,
          ApplicationPermissions.unitedWayAdmin,
          ApplicationPermissions.wrkPlUserSetup,
          ApplicationPermissions.wrkPlDataEntry,
          ApplicationPermissions.wrkPlCampaignDashboardOnly,
          ApplicationPermissions.wrkPlEmployeeGroupMgmt]
        }
      },
      {
        path: 'report',
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('@uw/modules/report/report.module').then(
            (m) => m.ReportModule
          ),
        data: {
          permission: [ApplicationPermissions.wrkPlCampaignSetup,
          ApplicationPermissions.wrkPlCompanyLevel,
          ApplicationPermissions.unitedWayAdmin,
          ApplicationPermissions.reportAdmin,
         // ApplicationPermissions.wrkPlUserSetup,
         // ApplicationPermissions.wrkPlDataEntry,
         // ApplicationPermissions.wrkPlEmployeeGroupMgmt,
          ApplicationPermissions.reportAdHoc,
          ApplicationPermissions.reportAllCanvassers,
          ApplicationPermissions.reportCampaignHierarchy,
          ApplicationPermissions.reportCanvasser,
          ApplicationPermissions.reportCashChequeCreditCardPaidUA,
          ApplicationPermissions.reportCashChequeCreditCardReceivedWA,
          ApplicationPermissions.reportCharityAllocationSummary,
          ApplicationPermissions.reportCompanyCampaignExtractedAndUnExtracted,
          ApplicationPermissions.reportCompanyCampaignExtractedReconciliation,
          ApplicationPermissions.reportCompanyCampaignHierarchy,
          ApplicationPermissions.reportCompanyCampaignUnpaid,
          ApplicationPermissions.reportCompanyCampaignWorkplace,
          ApplicationPermissions.reportCompanyLevelPayrollDeductions,
          ApplicationPermissions.reportCorpAllCanvassers,
          ApplicationPermissions.reportCorpCampaignHierarchy,
          ApplicationPermissions.reportCorpEmployeeStatus,
          ApplicationPermissions.reportDailyStatus,
          ApplicationPermissions.reportDecidedUnDecidedFinancial,
          ApplicationPermissions.reportDecidedUnDecidedNonFinancial,
          ApplicationPermissions.reportEditAdHoc,
          ApplicationPermissions.reportEmployeeStatus,
          ApplicationPermissions.reportEmployeeTransaction,
          ApplicationPermissions.reportFairShare_Co,
          ApplicationPermissions.reportFairShare_Internal,
          ApplicationPermissions.reportLeadershipStatus,
          ApplicationPermissions.reportLeadershipSummary,
          ApplicationPermissions.reportLocalResults,
          ApplicationPermissions.reportLocalUWResults,
          ApplicationPermissions.reportLocalUWResultsReportNationalCampaigns,
          ApplicationPermissions.reportLocalUWResultsReportNationalCampaigns_FR,
          ApplicationPermissions.reportOverallStatus,
          ApplicationPermissions.reportPaymentGatewayRecDetail,
          ApplicationPermissions.reportPaymentGatewayRecSum,
          ApplicationPermissions.reportPayrollDeductions,
          ApplicationPermissions.reportSurveyQuestion,
          ApplicationPermissions.reportSweepstakes,
          ApplicationPermissions.reportUpsellStatus,
        ]
        }
      },
      {
        path: 'employee',
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('@uw/modules/employee-search/employee-search.module').then(
            (m) => m.EmployeeSearchModule
          ),
        data: {
          permission: [
            ApplicationPermissions.unitedWayAdmin,
          ]
        }
      },
      {
        path: 'transaction',
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('@uw/modules/transaction-search/transaction-search.module').then(
            (m) => m.TransactionSearchModule
          ),
        data: {
          permission: [
            ApplicationPermissions.unitedWayAdmin,
          ]
        }
      },
      {
        path: 'file_upload',
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('@uw/modules/file-upload/file-upload.module').then(
            (m) => m.FileUploadModule
          ),
        data: { permission: [ApplicationPermissions.uwUploadExtract] }
      },
      {
        path: 'campaign_extract',
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('@uw/modules/campaign-extract/campaign-extract.module').then(
            (m) => m.CampaignExtractModule
          ),
        data: { permission: [ApplicationPermissions.uwUploadExtract] }
      },
      {
        path: 'past_extracts',
        canActivate: [PermissionGuard],
        loadChildren: () =>
          import('@uw/modules/past-extracts/past-extracts.module').then(
            (m) => m.PastExtractsModule
          ),
        data: { permission: [ApplicationPermissions.uwUploadExtract] }
      },
      {
        path: 'home',
        loadChildren: () =>
          import('@uw/modules/landing/landing.module').then(
            (m) => m.LandingModule
          ),
      },
      {
        path: '**',
        redirectTo: 'uwsetup',
        pathMatch: 'full'
      },
    ],
  },
  // {
  //   path: 'reset-password',
  //   component: ResetPasswordComponent,
  //   resolve: {
  //     auth: AuthPagesResolver
  //   },
  // },
  {
    path: '**',
    redirectTo: 'private',
    pathMatch: 'full'
  },
  {
    path: 'error',
    component: ErrorPageComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: "always"
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
